import apiClient from '../connections/api'

export const validateSpm = (spm) => {
    return apiClient.get(`/documents/validate/${encodeURIComponent(spm)}`)
}

export const prepareUpload = (paths, associateSpm) => {
    return apiClient.post('/documents/upload-prep', { paths, associateSpm })
}

export const confirmUpload = (spm, uploads) => {
    return apiClient.post('/documents/upload-confirm', { spm, uploads })
}

export const getAllSpmDocuments = () => {
    return apiClient.get('/documents')
}

export const getSpmDocumentSteps = (spm) => {
    return apiClient.get(`/documents/${encodeURIComponent(spm)}/steps`)
}

export const deleteSpm = (spm) => {
    return apiClient.delete(`/documents/${encodeURIComponent(spm)}`)
}

export const deleteSpmStep = (spm, stepName) => {
    return apiClient.delete(
        `/documents/${encodeURIComponent(spm)}/step/${encodeURIComponent(stepName)}`
    )
}

export const deleteSpmFile = (spm, stepName, filename) => {
    return apiClient.delete(
        `/documents/${encodeURIComponent(spm)}/step/${encodeURIComponent(stepName)}/file/${encodeURIComponent(filename)}`
    )
}

export const renameSpm = (spm, newSpm) => {
    return apiClient.put(`/documents/${encodeURIComponent(spm)}`, { newSpm })
}

export const renameSpmStep = (spm, stepName, newStepName) => {
    return apiClient.put(
        `/documents/${encodeURIComponent(spm)}/step/${encodeURIComponent(stepName)}`,
        { newStepName }
    )
}

export const renameSpmFile = (spm, stepName, filename, newFilename) => {
    return apiClient.put(
        `/documents/${encodeURIComponent(spm)}/step/${encodeURIComponent(stepName)}/file/${encodeURIComponent(filename)}`,
        { newFilename }
    )
}

const documentsRoutes = {
    validateSpm,

    prepareUpload,
    confirmUpload,
    getAllSpmDocuments,
    getSpmDocumentSteps,
    deleteSpm,
    deleteSpmStep,
    deleteSpmFile,
    renameSpm,
    renameSpmStep,
    renameSpmFile
}

export default documentsRoutes
